import { render, staticRenderFns } from "./ScrollPanel.vue?vue&type=template&id=7695aaa4&scoped=true&"
import script from "./ScrollPanel.vue?vue&type=script&lang=ts&"
export * from "./ScrollPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollPanel.vue?vue&type=style&index=0&id=7695aaa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695aaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
